import { focusMainApp, Keys } from "keyboard";
import * as React from "react";
import { Tip } from "view/tooltips";
export const SEARCH_BOX_ID = "search-box-input";
export class SearchBox extends React.Component {
    constructor() {
        super(...arguments);
        this.inputRef = React.createRef();
        this.state = { value: "", focused: false };
        this.onChange = (e) => {
            const value = e.target.value;
            this.setState({ value });
            if (this.props.throttleMs) {
                // Reset throttle timer.
                if (this.interval)
                    window.clearTimeout(this.interval);
                this.interval = window.setTimeout(() => {
                    this.props.onChange(value);
                }, this.props.throttleMs);
            }
            else {
                this.props.onChange(value);
            }
        };
        this.isActive = () => this.state.value.length > 0;
        this.render = () => {
            var _a;
            return React.createElement("div", { className: `search-box-container ${"active".if(this.isActive())} ${"focused".if(this.state.focused)} ${(_a = this.props.className) !== null && _a !== void 0 ? _a : ""}`, key: "box" },
                React.createElement("i", { className: `fa ${this.isActive() ? "fa-backspace" : "fa-search"}`, key: "icon", onClick: _ => {
                        if (this.isActive()) {
                            // Erase field.
                            this.setState({ value: "" });
                            this.props.onChange("");
                        }
                        this.inputRef.current.focus();
                    } }),
                React.createElement(Tip, { content: this.props.tooltip },
                    React.createElement("input", { key: "input", id: SEARCH_BOX_ID, ref: this.inputRef, value: this.state.value, onFocus: _ => this.setState({ focused: true }), onChange: this.onChange, onBlur: e => { var _a; this.setState({ focused: false }); (_a = this.props.onBlur) === null || _a === void 0 ? void 0 : _a.call(null, e.target.value); }, onKeyUp: e => { if (e.keyCode == Keys.ESCAPE)
                            focusMainApp(); }, placeholder: this.props.placeholder })));
        };
    }
    static getDerivedStateFromProps(nextProps, state) {
        if (!state.focused) {
            return Object.assign(Object.assign({}, state), { value: nextProps.value });
        }
        return state;
    }
}
